"use client";

import React from "react";
import "./heroContent.css";

const images = [
    { url: "https://ik.imagekit.io/bpfumapog/carousel1.png?tr=f-auto,q-80", title: "carousel-1" },
    { url: "https://ik.imagekit.io/bpfumapog/carousel2.png?tr=f-auto,q-80", title: "carousel-2" },
    { url: "https://ik.imagekit.io/bpfumapog/carousel3.png?tr=f-auto,q-80", title: "carousel-3" },
    { url: "https://ik.imagekit.io/bpfumapog/carousel4.png?tr=f-auto,q-80", title: "carousel-4" },
    { url: "https://ik.imagekit.io/bpfumapog/carousel5.png?tr=f-auto,q-80", title: "carousel-5" },
    { url: "https://ik.imagekit.io/bpfumapog/carousel6.png?tr=f-auto,q-80", title: "carousel-6" },
    { url: "https://ik.imagekit.io/bpfumapog/carousel7.png?tr=f-auto,q-80", title: "carousel-7" },
];

export default function HeroContent() {
    const logos = images.map((image, index) => (
        <img
            className={`max-w-[390px] max-h-[288px] md:max-w-[1205px] md:max-h-[704px] h-auto mx-2 md:mx-4 shadow-custom rounded-[8px] md:rounded-[16px] my-5`}
            key={index}
            src={image.url}
            alt={image.title}
        />
    ));


    return (
        <div className="w-full">
            <div className={"flex py-4 md:py-20 flex-col mt-4 md:mt-0"}>
                <div className="inline-flex flex-nowrap mt-4 md:mt-12 w-full overflow-hidden">
                    <div className="flex animate-infinite-scroll">{logos}</div>
                    <div className="flex animate-infinite-scroll" aria-hidden="true">
                        {logos}
                    </div>
                </div>
            </div>
        </div>
    );
}
